const s = {
  name: "Clock",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,4v3h2V4H19z"/>
		<path class="st0" d="M19,36v-3h2v3H19z"/>
		<path class="st0" d="M11.1,6.6l1.5,2.6l1.7-1l-1.5-2.6L11.1,6.6z"/>
		<path class="st0" d="M27.1,34.4l-1.5-2.6l1.7-1l1.5,2.6L27.1,34.4z"/>
		<path class="st0" d="M5.6,12.9l2.6,1.5l1-1.7l-2.6-1.5L5.6,12.9z"/>
		<path class="st0" d="M33.4,28.9l-2.6-1.5l1-1.7l2.6,1.5L33.4,28.9z"/>
		<path class="st0" d="M4,21h3v-2H4V21z"/>
		<path class="st0" d="M36,21h-3v-2h3V21z"/>
		<path class="st0" d="M6.6,28.9l2.6-1.5l-1-1.7l-2.6,1.5L6.6,28.9z"/>
		<path class="st0" d="M34.4,12.9l-2.6,1.5l-1-1.7l2.6-1.5L34.4,12.9z"/>
		<path class="st0" d="M12.9,34.4l1.5-2.6l-1.7-1l-1.5,2.6L12.9,34.4z"/>
		<path class="st0" d="M28.9,6.6l-1.5,2.6l-1.7-1l1.5-2.6L28.9,6.6z"/>
		<path class="st0" d="M21,9v10h8v2H19V9H21z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18
			c9.9,0,18,8.1,18,18c0,9.9-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Clock
};
